import React, { useEffect, useRef, useState } from 'react';
import { FiSearch, FiXCircle } from 'react-icons/fi';
import { RoundedTextField } from '../Form';
import { CircularProgress, IconButton } from '@mui/material';
import { ShowWhenWithAnimation, VisibleWhen } from '../Others/ShowWhen';

export default function SearchInputField({ onChange, placeholder = 'Search', delay = 500, style={}, value = '', valueRefreshDependencyArray = [], isSearching = false, ...props }) {
    const [text, setText] = useState('');
    const timeout = useRef(null);

    function handleText(text) {
        setText(text);

        clearTimeout(timeout.current);
        timeout.current = setTimeout(() => {
            if (onChange) onChange(text);
        }, delay);
    }

    useEffect(() => {
        setText(value);
    }, [...valueRefreshDependencyArray]);

    return (
        <RoundedTextField
            {...props}
            placeholder={placeholder}
            containerSx={style}
            sx={{'& input' : {pr: '24px'}}}

            startIcon={
                <ShowWhenWithAnimation
                    when={!isSearching}
                    otherwise={
                        <CircularProgress size={20} />
                    }
                >
                    <FiSearch className='center' style={{ width: '20px', height: '20px' }} />
                </ShowWhenWithAnimation>
            }

            endIcon={
                <VisibleWhen when={!!text} style={{position: 'absolute', right: '2px'}} >
                    <IconButton 
                        onClick={() => handleText('')} 
                        sx={{ borderRadius: '10px'}} 
                    >
                        <FiXCircle style={{width: '24px', height: '24px'}} />
                    </IconButton>
                </VisibleWhen>
            }

            autoComplete={'off'}
            value={text}
            onChange={({ target }) => { handleText(target.value) }}
        />
    )
}